import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { ConfirmationSlice } from '@/features/Confirmation';
import { SettingsSlice } from '@/processes/Settings';
import { MinerAccountsSlice } from '@/processes/MinerAccounts';
import { YEAR_IN_MS } from '@/shared/constants/date';
import { createWrapper } from 'next-redux-wrapper';
import { nextReduxCookieMiddleware, wrapMakeStore } from "next-redux-cookie-wrapper";
import { api } from './api';
import modalSlice from '@/shared/slices/modalSlice';
import { IS_DEV } from '@/shared/constants/env';

const makeStore = () => {
  const store = configureStore({
    reducer: combineReducers({ 
      confirmation: ConfirmationSlice,
      settings: SettingsSlice,
      minerAccounts: MinerAccountsSlice,
      modal: modalSlice,
      [api.reducerPath]: api.reducer,
    }),
    devTools: IS_DEV,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false,
    }).prepend(
      nextReduxCookieMiddleware({
        expires: new Date(new Date().getTime() + YEAR_IN_MS),
        subtrees: [
          {
            subtree: `minerAccounts.recentSearches`,
            cookieName: "cookie:persist:recentSearches",
          },
          {
            subtree: `settings`,
            cookieName: "cookie:persist:settings",
          },
        ],
      })
    ).concat(api.middleware),
  });
  return store;
};

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export const wrapper = createWrapper(wrapMakeStore(makeStore));
